document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById('cta_layout_fixed_bottom')) {
        const cta_layout_fixed_bottom = document.getElementById('cta_layout_fixed_bottom');

        if (cookie_exists('blog_alice_cta_layout_fixed_bottom', 'close') == true) {
            cta_layout_fixed_bottom.style.display = 'none';
        } else {
            cta_layout_fixed_bottom.style.display = 'show';
        }

        const cta_layout_fixed_bottom_button = document.getElementById('cta_layout_fixed_bottom_button');
        cta_layout_fixed_bottom_button.addEventListener('click', function () {
            const expiration_date = new Date();
            expiration_date.setDate(expiration_date.getDate() + 7);
            document.cookie = 'blog_alice_cta_layout_fixed_bottom=close; expires=' + expiration_date.toUTCString() + '; path=/';

            cta_layout_fixed_bottom.style.display = 'none';
        });
    }

    if (document.getElementById('cta_layout_fullwide_newsletter')) {
        const cta_newsletter_form = document.querySelector("#cta_layout_fullwide_newsletter .form");
        const cta_newsletter_email = document.querySelector("#cta_layout_fullwide_newsletter .email");
        const cta_newsletter_alert = document.querySelector("#cta_layout_fullwide_newsletter .alert");
        const cta_newsletter_success = document.querySelector("#cta_layout_fullwide_newsletter .success");
        const cta_newsletter_button = document.querySelector("#cta_layout_fullwide_newsletter .form button");
        const cta_newsletter_loading = document.querySelector("#cta_layout_fullwide_newsletter .loading");
        const cta_newsletter_form_id = cta_newsletter_form.getAttribute("data-form-id");

        cta_newsletter_button.addEventListener("click", function (e) {
            if (cta_newsletter_email.validity.valid) {
                cta_newsletter_alert.style.display = "none";

                cta_newsletter_button.setAttribute("disabled", true);
                cta_newsletter_loading.style.display = "flex";
                cta_newsletter_form.style.opacity = "0.2";

                var data = JSON.stringify({
                    "fields": [
                        {
                            "name": "email",
                            "value": cta_newsletter_email.value
                        }
                    ]
                });

                var xhr = new XMLHttpRequest();
                xhr.open("POST", "https://api.hsforms.com/submissions/v3/integration/submit/" + hubspot_id + "/" + cta_newsletter_form_id);
                xhr.setRequestHeader("Content-Type", "application/json");

                xhr.onload = function () {
                    if (xhr.status === 200 || xhr.status === 204) {
                        cta_newsletter_success.style.display = "block";
                        cta_newsletter_form.style.display = "none";
                        cta_newsletter_loading.style.display = "none";
                    } else {
                        cta_newsletter_form.classList.add('form--error');
                        cta_newsletter_alert.innerHTML = 'Ops! Algo deu errado, tente novamente mais tarde!';
                        cta_newsletter_button.setAttribute("disabled", false);
                        cta_newsletter_loading.style.display = "none";
                        cta_newsletter_form.style.opacity = "100";
                    }
                };

                xhr.send(data);
            } else {
                cta_newsletter_form.classList.add('form--error');
                cta_newsletter_alert.innerHTML = 'Por favor, insira um e-mail válido!';
            }
        });

        cta_newsletter_email.addEventListener("input", function (e) {
            e.preventDefault();

            if (cta_newsletter_email.validity.valid) {
                cta_newsletter_form.classList.remove('form--error');
            } else {
                cta_newsletter_form.classList.add('form--error');
                cta_newsletter_alert.innerHTML = 'Por favor, insira um e-mail válido!';
            }
        });
    };

    if (cookie_exists('blog_cta_lightbox_loaded', 'true') === false) {
        if (document.getElementById('cta_lightbox')) {
            const expiration_date = new Date();
            expiration_date.setMonth(expiration_date.getMonth() + 3);

            setTimeout(function () {
                const cta_lightbox = document.getElementById('cta_lightbox');
                if (cta_lightbox) {
                    cta_lightbox.style.display = 'flex';

                    document.cookie = 'blog_cta_lightbox_loaded=true; expires=' + expiration_date.toUTCString() + '; path=/';
                }
            }, 10000);
    
            window.addEventListener("scroll", function () {
                var scroll_percentage = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
                if (scroll_percentage > 50) {
                    const cta_lightbox = document.getElementById('cta_lightbox');
                    if (cta_lightbox) {
                        cta_lightbox.style.display = 'flex';

                        document.cookie = 'blog_cta_lightbox_loaded=true; expires=' + expiration_date.toUTCString() + '; path=/';
                    }
                }
            });
    
            const close_lightbox = document.getElementById("cta_lightbox_full_button");
            if (close_lightbox) {
                const cta_lightbox = document.getElementById('cta_lightbox');
                close_lightbox.addEventListener("click", function () {
                    cta_lightbox.parentNode.removeChild(cta_lightbox);
                });
            }
        }
    }
});